import Modal, { ModalProps } from "react-bootstrap/Modal";

import { THEME } from "@/styles/theme";

import { FormUnitSelection } from "../FormUnitSelection";

type Props = ModalProps;

export function ModalUnitSelection({ ...rest }: Props) {
	return (
		<Modal size="lg" {...rest}>
			<Modal.Header
				closeVariant="white"
				closeButton
				style={{ backgroundColor: THEME.COLORS.INFO }}
			>
				<Modal.Title className="text-white">Seleção de unidades liberadas</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<FormUnitSelection />
			</Modal.Body>
		</Modal>
	);
}
